import ClearIcon from '@/components/Icons/ClearIcon';
import { Button, ButtonProps } from '@mui/material';

interface IProps extends ButtonProps {
  label?: string;
}

const ClearAllButton = ({ label, sx, ...props }: IProps) => {
  return (
    <Button
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        fontWeight: 600,
        fontSize: 14,
        displayPrint: 'none',
        ...sx,
      }}
      {...props}
    >
      <ClearIcon />
      <span>{label ?? 'Clear all'}</span>
    </Button>
  );
};

export default ClearAllButton;
